<template>
  <!-- The generator's Visual / Code tab switcher: SectionTabs placed in the
       page's content column, with the live color counts attached to each tab.
       The tab objects themselves come from usePaletteView, which owns `current`. -->
  <SectionColumn :dim="dim">
    <SectionTabs :tabs="countedTabs" :is-loading="isLoading" @change="(tab) => $emit('change', tab.source)" />
  </SectionColumn>
</template>

<script setup>
import { computed } from 'vue'
import SectionColumn from '~/components/atoms/SectionColumn.vue'
import SectionTabs from '~/components/organisms/SectionTabs.vue'

const props = defineProps({
  tabs: { type: Array, required: true },
  visualCount: { type: Number, default: 0 },
  codeCount: { type: Number, default: 0 },
  isLoading: { type: Boolean, default: false },
  dim: { type: Boolean, default: false },
})
defineEmits(['change'])

// Counts are positional (visual first, code second), matching usePaletteView.
// `source` carries the original object back out so the page's `changePaletteView`
// still receives the very tab it owns, not this copy.
const countedTabs = computed(() =>
  props.tabs.map((tab, index) => ({
    ...tab,
    count: index === 0 ? props.visualCount : props.codeCount,
    source: tab,
  })),
)
</script>
